import {
  BLUR,
  BUSY_ON_TEMPORARY,
  CHANGE,
  CLEAR_SUBMIT,
  CUSTOM_VALIDATION,
  DESTROY,
  FOCUS,
  FORCE_RELOAD,
  INITIALIZE,
  LOAD_DATA,
  MERGE_CONFLICTS,
  REGISTER_FIELD,
  RESET,
  SET_ROW_INDEX,
  SET_SUBMIT_FAILED,
  SET_SUBMIT_SUCCEEDED,
  START_SUBMIT,
  START_VALIDATION,
  STOP_SUBMIT,
  STOP_VALIDATION,
  SUBMIT,
  TEMPORARY_SAVE_SUCCEEDED,
  UNREGISTER_FIELD,
  UPDATE_MUTATION_ID,
} from './actionTypes';

export const blur = (form, field, value, touch, mutationId) => ({
  type: BLUR,
  meta: { form, field, touch, mutationId },
  payload: value,
});

export const change = (form, field, value, touch, mutationId) => {
  return {
    type: CHANGE,
    meta: { form, field, touch, mutationId },
    payload: value,
  };
};

export const clearSubmit = (form) => ({ type: CLEAR_SUBMIT, meta: { form } });

export const destroy = (...form) => ({ type: DESTROY, meta: { form } });

export const focus = (form, field) => ({ type: FOCUS, meta: { form, field } });

export const initialize = (form, values, describe) => {
  return { type: INITIALIZE, meta: { form }, payload: values, describe };
};

export const registerField = (form, dataid, type, tabId) => ({
  type: REGISTER_FIELD,
  meta: { form },
  payload: { dataid, type, tabId },
});

export const reset = (form) => ({ type: RESET, meta: { form } });

export const forceReload = (form) => ({ type: FORCE_RELOAD, meta: { form } });

export const setSubmitFailed = (form, ...fields) => ({
  type: SET_SUBMIT_FAILED,
  meta: { form, fields },
  error: true,
});

export const setSubmitSucceeded = (form, ...fields) => ({
  type: SET_SUBMIT_SUCCEEDED,
  meta: { form, fields },
  error: false,
});

export const startSubmit = (form) => ({ type: START_SUBMIT, meta: { form } });

export const stopSubmit = (form, errors) => {
  const action = {
    type: STOP_SUBMIT,
    meta: { form },
    payload: errors,
  };
  if (errors && Object.keys(errors).length) {
    action.error = true;
  }
  return action;
};

export const submit = (form) => ({ type: SUBMIT, meta: { form } });

export const unregisterField = (form, dataid, destroyOnUnmount = true) => ({
  type: UNREGISTER_FIELD,
  meta: { form },
  payload: { dataid, destroyOnUnmount },
});

export const dataLoading = (form) => {
  return { type: LOAD_DATA, meta: { form } };
};

export const setRowIndex = (form, field, value) => ({
  type: SET_ROW_INDEX,
  meta: { form, field, value },
});

export const startValidation = (form, field) => ({
  type: START_VALIDATION,
  meta: { form, field },
});

export const stopValidation = (form, errors) => {
  const action = {
    type: STOP_VALIDATION,
    meta: { form },
    payload: errors,
  };
  if (errors && Object.keys(errors).length) {
    action.error = true;
  }
  return action;
};

export const customValidation = (form, field, error) => {
  return {
    type: CUSTOM_VALIDATION,
    meta: { form },
    payload: {
      field,
      error,
    },
  };
};

export const temporarySaveSucceeded = (form, values, valuesSubmitted, mutationId, ignoreMutationIdCheck = false) => {
  return {
    type: TEMPORARY_SAVE_SUCCEEDED,
    meta: { form, mutationId, ignoreMutationIdCheck },
    payload: { values, valuesSubmitted },
  };
};

export const updateMutationId = (form, mutationId) => {
  return {
    type: UPDATE_MUTATION_ID,
    meta: { form, mutationId },
    payload: { mutationId },
  };
};

export const mergeConflicts = (form, conflicts) => {
  return {
    type: MERGE_CONFLICTS,
    meta: { form },
    payload: conflicts,
  };
};

export const busyOnTemporary = (form, mutationId) => ({ type: BUSY_ON_TEMPORARY, meta: { form, mutationId } });
